<form [formGroup]="modelForm" (ngSubmit)="isFormSubmitted = true;addComment()">
  <div class="modal-dialog-centered detail-modal">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Add Comment</h4>
        <button type="button" class="btn-close" aria-label="Close"
          (click)="activeModal.dismiss('Cross click')"></button>
      </div>
      <div class="modal-body">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="mb-2">
                  <label for="commentDate" class="form-label">Comment Date</label>
                  <input type="datetime-local" class="form-control form-control-sm" formControlName="txtDateTime"
                    [min]="currentCommentDate" max="9999-12-31T23:59"
                    [ngClass]="{'is-invalid': (isFormSubmitted || modelForm.get('txtDateTime').touched) && modelForm.get('txtDateTime').errors}">
                    <div *ngIf="(isFormSubmitted || modelForm.get('txtDateTime').touched) && modelForm.get('txtDateTime').errors"
                      class="invalid-feedback">
                    <span *ngIf="modelForm.get('txtDateTime').errors.required">Date is required.</span>
                  </div>
                  </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="mb-2">
                  <textarea class="form-control custom-textbox" placeholder="Leave a comment here" id="floatingTextarea"
                    formControlName="txtComment" (keyup)="countCharcter()"
                    [ngClass]="{'is-invalid': (CountReachedMsg || isFormSubmitted || modelForm.get('txtComment').touched) && modelForm.get('txtComment').errors}">
                      </textarea>
                  <div *ngIf="(CountReachedMsg || isFormSubmitted || modelForm.get('txtComment').touched) && modelForm.get('txtComment').errors"
                    class="invalid-feedback">
                    <span *ngIf="modelForm.get('txtComment').errors.required">Comments are required.</span>
                    <span *ngIf="modelForm.get('txtComment').errors.pattern">Maximum character Count ({{characterLimit}}) exceeded.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <span class="ms-3">( AWB No: {{ cellAWbnumber }} )</span>
        <span class="char-count" id="charCount">Character Count: {{charCount}}</span>
        <button type="submit" class="btn btn-primary" data-dismiss="modal">Save</button>
      </div>
    </div>
  </div>
</form>